/** Common entry visibility only. Existing routes, cached drafts and server permissions stay intact. */
export const SELLER_ENTRY_MODULES = [
  'PLUGIN', 'ONLINE_PRODUCTS', 'COLLECTION', 'PRICING_PROFIT', 'BILLING', 'SHOPS_GROUPS', 'ORDERS',
  'SELECTION_ANALYTICS', 'ALIBABA1688', 'PROMOTIONS', 'RETURNS', 'MESSAGES', 'SALES_REPORTS',
  'WALLET', 'EXTERNAL_DEEPSEEK', 'EXTERNAL_LOGISTICS',
] as const
export type SellerEntryModule = typeof SELLER_ENTRY_MODULES[number]
export const DEFAULT_SELLER_ENTRIES = SELLER_ENTRY_MODULES.slice(0, 7)
export const SELLER_ENTRY_LABELS: Record<SellerEntryModule, string> = {
  PLUGIN: '浏览器插件一键上架', ONLINE_PRODUCTS: '在线商品与编辑再上架', COLLECTION: '采集箱与编辑上架',
  PRICING_PROFIT: '定价与利润', BILLING: '套餐与用量', SHOPS_GROUPS: '店铺与分组维护', ORDERS: '我的订单',
  SELECTION_ANALYTICS: '选品分析', ALIBABA1688: '1688选品铺货', PROMOTIONS: '促销', RETURNS: '退货案件',
  MESSAGES: '消息', SALES_REPORTS: '经营数据与销售报表', WALLET: '钱包', EXTERNAL_DEEPSEEK: 'DeepSeek入口', EXTERNAL_LOGISTICS: '物流查询入口',
}
const SUPPORT_ROOTS = ['/workbench', '/settings', '/help', '/notifications']
const MODULE_ROOTS: Partial<Record<SellerEntryModule, string[]>> = {
  ONLINE_PRODUCTS: ['/products'], COLLECTION: ['/collection'], PRICING_PROFIT: ['/pricing', '/tools/pricing'],
  BILLING: ['/billing'], SHOPS_GROUPS: ['/shops', '/shop-groups', '/watermarks'], ORDERS: ['/orders'],
  SELECTION_ANALYTICS: ['/selection', '/phase2/selection-analytics'], ALIBABA1688: ['/sourcing/1688'],
  PROMOTIONS: ['/promotions', '/phase2/auto-promotion-removal'], RETURNS: ['/returns'],
  MESSAGES: ['/messages', '/phase2/advanced-messaging'], SALES_REPORTS: ['/datascreen', '/reports/sales'],
  WALLET: ['/wallet'], EXTERNAL_DEEPSEEK: ['/external/deepseek'], EXTERNAL_LOGISTICS: ['/external/logistics'],
}

export function sellerEntryVisible(path: string, visibleModules: readonly SellerEntryModule[] = DEFAULT_SELLER_ENTRIES): boolean {
  const pathname = path.split(/[?#]/, 1)[0] ?? ''
  const matches = (root: string) => pathname === root || pathname.startsWith(root + '/')
  return SUPPORT_ROOTS.some(matches)
    || (matches('/listing/records') && visibleModules.some(module => module === 'ONLINE_PRODUCTS' || module === 'COLLECTION'))
    || visibleModules.some(module => MODULE_ROOTS[module]?.some(matches))
}

export const SELLER_CORE_FUNCTIONS = DEFAULT_SELLER_ENTRIES.map(module => SELLER_ENTRY_LABELS[module])
